import { typedEntries } from '@utils/entries';
import { auctionConfigurationState, AuctionConfigValidatableFields } from './fields';
import { clearAuctionConfigurationErrors } from './helpers';

export const validateAuctionConfiguration = () => {
  clearAuctionConfigurationErrors();

  const result = AuctionConfigValidatableFields.safeParse(auctionConfigurationState.fields);

  if (!result.success) {
    result.error.issues.map(({ path, message }) => {
      if (path?.[0] === 'addresses') {
        auctionConfigurationState.errors.addresses = message;
      }
      if (path?.[0] === 'manuallyAddedAllowlist') {
        auctionConfigurationState.errors.manuallyAddedAllowlist['description'] = message;
      }
    });
    typedEntries(result.error.flatten().fieldErrors).forEach(([key, value]) => {
      if (!value || !value[0] || key === 'manuallyAddedAllowlist') return;
      auctionConfigurationState.errors[key] = value[0];
    });
    auctionConfigurationState.isValid = false;
    return;
  }

  auctionConfigurationState.isValid = true;
  return result.data;
};
